import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { loginUser } from "core/redux/features/auth/loginSlice";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

const Login = () => {
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginSlider = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!userId || !date) {
      return;
    }
    // console.log("password--->",date)
    const user = await dispatch(loginUser({ userId, password: date }));
    if (user?.payload?.success) {
      const token = user?.payload?.token;
      const image = user?.payload?.user?.image;
      const _id = user?.payload?.user?._id;
      const first_name = user?.payload?.user?.first_name;
      const last_name = user?.payload?.user?.last_name;

      if (token) localStorage.setItem("token", token);
      if (image) localStorage.setItem("image", `https://indianairways.net/storage/${image}`);
      localStorage.setItem("roles", "Student"); // static, no need to check
      if (_id) localStorage.setItem("_id", _id);
      if (first_name) localStorage.setItem("first_name", first_name);
      if (last_name) localStorage.setItem("last_name", last_name);

      toast.success(user?.payload?.message || "Student Login Successfully");
      navigate(all_routes.studentDashboard);
    }
    else {
      toast.error(user?.payload?.message || "Invalid Credentials");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="login-content">
        <div className="row">
          {/* Banner Section */}
          <div className="col-md-6 login-bg d-none d-lg-flex">
            <div className="mx-auto">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="assets/img/auth/auth-1.svg"
                    className="img-fluid"
                    alt="Banner"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h3 className="mb-2">
                    Welcome to
                    {" "}<span className="text-secondary">AIATI in India.</span>{" "}
                  </h3>
                  <p>
                    A trusted platform to manage, deliver, and track aviation learning .
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Login Form Section */}
          <div className="col-md-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="w-100">
                  <div className="d-flex align-items-center justify-content-between login-header mb-4">
                    <img
                      src="/assets/img/logo/AviationLogo-08.png"
                      alt="Logo"
                      height="70"
                      style={{ height: "70px" }}
                    />
                  </div>

                  <h1 className="fs-32 fw-bold mb-4">Sign into Your Account</h1>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">
                        Email or Mobile No. <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-lg ${submitted && !userId ? "is-invalid" : ""
                          }`}
                        autoComplete="username"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Date of birth <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control form-control-lg ${submitted && !date ? "is-invalid" : ""
                          }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>

                    <div className="d-grid mb-3">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-lg"
                      >
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
